<template>
  <div>
    <a-row>
      <g-master :name="master.endpoint"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
                :parentData="parentData"
                @action="masterAction"
                ref="master"
      >
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions" v-if="isvisibleTalla">
              <g-dropdown :label="$t('Tallas')"
                          :selectConfig="{mode:'multiple'}"
                          :formItemConfig="fiOptions"
                          endpoint="hierarchy_lookup"
                          :params="tallas"
                          :decorator="['garment_size']">
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions" v-if="isedit">
              <a-form-item :label="$t('Estado')" :has-feedback="false">
                <a-checkbox
                  v-decorator="['status', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                </a-checkbox>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions"  v-if="isedit">
              <a-form-item :label="$t('Valor')">
                <a-input-number style="width: 100%" v-decorator="['garment_value', { rules: [{ required: false }] }]"/>
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </g-master>
    </a-row>
  </div>
</template>

<script>
  export default {
    props: ['id_garment_type'],
    data () {
      return {
        isedit: false,
        isvisibleTalla: false,
        tallas: {
          h_lookup_type: 'TIPO_PRENDA_TALLA'
        },
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'garment_size_dot',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'Talla', dataIndex: 'talla_desc', sorter: true},
              {title: 'Valor', dataIndex: 'garment_value', sorter: true},
              {title: 'Estado', dataIndex: 'status_desc', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'status', type: 'boolean'},
            {name: 'garment_value'}
          ]
        }
      }
    },
    computed: {
      parentData () {
        return {
          id_garment_type: this.id_garment_type
        }
      }
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'masterCreate':
            this.isedit = false
            this.isvisibleTalla = true
            break
          case 'masterEdit':
            this.isvisibleTalla = false
            this.isedit = true
            break
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Dotaciones/GarmentSizeDot.vue